export const DB_SALARY_SERVICE_ADDENDUM = {
  id: 'a2c0a4b4-950b-43f4-bdac-99a7a20918ef',
  companyProperty: 'should_accept_salary_service_addendum_db',
  userProperty: 'salary_service_addendum_dismissed_at',
  getText: termsUrl =>
    `Please click <strong>'I accept'</strong> to accept the terms of the new <a href='${termsUrl}' target='_blank'>Salary Service Addendum</a>. This Salary Service Addendum supersedes any previous Salary Service Addendum or equivalent agreement entered into between Fourth (in its own right and as agent for and on behalf of Stream) and you relating to the Stream Service.`,
};

export const DB_TERMS_OF_BUSINESS_AMENDMENT = {
  // v2
  id: '7667B8C6-BAAA-40DF-A290-193DA27C49A9',
  companyProperty: 'should_accept_db_terms_of_business_amendment',
  userProperty: 'db_terms_of_business_amendment_dismissed_at',
  getText: termsUrl =>
    `Please review and click <strong>'I accept'</strong> to accept our new <a href='${termsUrl}' target='_blank'>Terms of Business.</a>.`,
};

export const HEALTHCARE_TERMS_OF_BUSINESS_AMENDMENT = {
  // v2
  id: 'BFC53F11-496E-4FDE-96F6-57C198600D10',
  companyProperty: 'should_accept_healthcare_terms_of_business_amendment',
  userProperty: 'healthcare_terms_of_business_amendment_dismissed_at',
  getText: termsUrl =>
    `Please review and click <strong>'I accept'</strong> to accept our new <a href='${termsUrl}' target='_blank'>Terms of Business.</a>.`,
};

export const MHR_TERMS_OF_BUSINESS_AMENDMENT = {
  id: '9FA998FE-15E1-4FF2-9F67-D6E2C402AAB6',
  companyProperty: 'should_accept_mhr_terms_of_business_amendment',
  userProperty: 'mhr_terms_of_business_amendment_dismissed_at',
  getText: termsUrl =>
    `Please review and click <strong>'I accept'</strong> to accept our new <a href='${termsUrl}' target='_blank'>Terms of Business.</a>.`,
};

export const LOOP_AGREEMENT = {
  id: 'D88412BE-4F84-4F15-B6A5-4C2C3343A783',
  companyProperty: 'should_accept_loop_agreement',
  userProperty: 'loop_agreement_dismissed_at',
  // eslint-disable-next-line no-unused-vars
  getText: termsUrl => {
    return `<span style='font-size: small;'><p style='font-size: medium;'><strong>We're very excited to announce that a Stream tile is available within Loop!</strong></p><p>This integration offers a powerful way to support the financial wellbeing of your colleagues, providing seamless access to essential tools like:</p><ul><li>Benefits Checker</li><li>Budgeting Tools</li><li>Savings Tools</li><li>Financial Coaches</li><li>Education</li><li>Instant Pay</li></ul><p>For existing Stream members, clicking the link will automatically open the app for quick access. For colleagues new to Stream, clicking the link will redirect them to the app store or Google Play Store to download the app and begin enrollment.</p><p>To ensure your colleagues can access these benefits as soon as they are available in Loop Web and Loop App, please tick "Yes, I consent" to confirm your consent to enable this feature.</p><p>Enabling Stream Connect will empower your workforce and contribute to a more financially resilient team.</p></span>`;
  },
};

export const W2_UPGRADE_NOTIFICATION = {
  id: '9073AD37-6363-42F5-B50B-AA3009158A9E',
  companyProperty: 'should_accept_w2_upgrade_notification',
  userProperty: 'w2_upgrade_notification_dismissed_at',
  // eslint-disable-next-line no-unused-vars
  getText: termsUrl => {
    return `<span style='font-size: small;'>
<p style='font-size: medium;'><strong>You're being upgraded</strong></p>
<p>We're excited to share that your Stream platform is evolving this June, with rewarding new features for your team, at no additional cost.</p>
<p>W2 is the latest version of the Stream platform designed to give your team a comprehensive set of benefits to support them in building better financial futures.</p>
<p>The release introduces:</p>
<ul>
  <li><strong>Savings that work harder:</strong> Unlock savings interest rates that outperform traditional high street banks.</li>
  <li><strong>Loans designed for fairness:</strong> Access clear, affordable borrowing options whenever you need it.</li>
  <li><strong>Financial education, reimagined:</strong> Engage with dynamic, personalized education delivered to you at exactly the right time.</li>
</ul>
<p>Your account will be upgraded in June/July 2025.</p>
<p>If you would like to remain on an older version of the Stream platform, please contact your Customer Success Manager or email us at customer.success@stream.co</p>
<p>Warmly,</p>
<p>The Stream Team</p>
</span>`;
  },
};

export const MYVIEW_PAYNOW_AMENDMENT = {
  id: 'F0880909-6AFA-45D3-8385-A88275674F1F',
  companyProperty: 'should_accept_myview_pay_now_amendment',
  userProperty: 'myview_pay_now_amendment_dismissed_at',
  getText: termsUrl =>
    `Please review and click <strong>'I accept'</strong> to accept our new <a href='${termsUrl}' target='_blank'>Terms of Business.</a>.`,
};
